// Десктопные push-уведомления браузера (Notification API) — раньше вообще не было ни
// запроса разрешения, ни самих уведомлений (только звук, см. sound.ts, и то не всегда
// заметно, если вкладка свёрнута) — см. отчёт пользователя "не запрашивает права на
// уведомления у браузера". Разрешение запрашивается один раз после входа (см. App.tsx),
// не сразу при открытии страницы — "холодный" запрос без предшествующего действия
// пользователя браузеры (особенно Chrome) всё равно частично глушат/автоблокируют.

import i18n from './i18n';

let requested = false;

export function requestNotificationPermission() {
  if (requested) return;
  requested = true;
  if (typeof Notification === 'undefined') return;
  if (Notification.permission !== 'default') return;
  Notification.requestPermission().catch(() => {});
}

/** Текстовое превью сообщения для уведомления — своя, более простая версия того, что
 *  ChatList.tsx рисует иконками (previewOf) — здесь нужна just plain-текстовая строка. */
export function notificationBody(msg: {
  payload: { data?: { text?: string; media?: { kind?: string; fileName?: string }[] } | null };
}): string {
  const text = msg.payload.data?.text;
  if (text) return text.length > 120 ? text.slice(0, 120) + '…' : text;
  const media = msg.payload.data?.media ?? [];
  const first = media[0];
  if (first) {
    if (first.kind === 'image') return i18n.t('misc2:notificationsPhoto');
    if (first.kind === 'video') return first.fileName ? i18n.t('misc2:notificationsVideo') : i18n.t('misc2:notificationsVideoMessage');
    if (first.kind === 'audio') return first.fileName ? i18n.t('misc2:notificationsAudio') : i18n.t('misc2:notificationsVoiceMessage');
    return i18n.t('misc2:notificationsFile');
  }
  return i18n.t('misc2:notificationsNewMessage');
}

export function showMessageNotification(title: string, body: string, onClick: () => void, chatId: string) {
  if (typeof Notification === 'undefined' || Notification.permission !== 'granted') return;
  // Всплывающее системное уведомление нужно только когда пользователь реально не смотрит в
  // приложение — если вкладка видна и в фокусе, достаточно бейджа в списке чатов
  // (звук сообщения включается отдельно в настройках).
  if (document.visibilityState === 'visible' && document.hasFocus()) return;
  const options = {
    body, icon: '/favicon.png', tag: 'chat-' + chatId, data: { chatId },
    actions: [
      { action: 'reply', title: i18n.t('misc:notificationReply') },
      { action: 'read', title: i18n.t('misc:notificationRead') },
    ],
  };
  const fallback = () => {
    try {
      const n = new Notification(title, { body, icon: options.icon, tag: options.tag, data: options.data });
      n.onclick = () => { window.focus(); onClick(); n.close(); };
    } catch { /* Браузер может разрешать уведомления только через service worker. */ }
  };
  if ('serviceWorker' in navigator) {
    void navigator.serviceWorker.getRegistration().then((registration) => {
      if (registration) return registration.showNotification(title, options);
      fallback();
    }).catch(fallback);
  } else fallback();
}
